import getLocalString from "constants/Localization";
import { useGetReportProductDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportProductDetails = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportProductDetailsMutation();
  const [getReportProductDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportProductDetails",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportProductDetails, { ...context, data }] as const;
};

export default useGetReportProductDetails;
